import { Component, Input } from '@angular/core';

@Component({
  selector: 'getm-tag-card-product',
  templateUrl: './tag-card-product.component.html',
  styleUrls: ['./tag-card-product.component.scss'],
})
export class TagCardProductComponent {

  public classResult: string = 'tl tr bl br';

  @Input() icon: string = '';
  @Input() label: string = '';
  @Input() color: string = 'primary';
  @Input() fill: 'solid' | 'outline' = 'solid';
  @Input() set corners(value: string) {
    const val = value?.trim().toLowerCase();
    this.classResult = val === 'none' ? '' :
      val === 'full' ? 'full' :
      (val === 'all' || !val) ? 'tl tr bl br' :
        (val.match(/(tl|tr|bl|br)/g) || []).join(' ');
  };

}
